module.exports = __webpack_public_path__ + "static/media/alvaro.9c42103a.jpg";